/**
 * @author Ivan Toth.
 * tables inside of the duplicate check
 */
var dcItemBindings = { item: '=', row: '<', comp: '<', filter: '=' };
var MultiController = (function () {
    function MultiController($scope, socket, settings, topic, Dialog, $state, $timeout, env, $http, notify, moment) {
        var _this = this;
        this.$scope = $scope;
        this.socket = socket;
        this.settings = settings;
        this.topic = topic;
        this.Dialog = Dialog;
        this.$state = $state;
        this.$timeout = $timeout;
        this.env = env;
        this.$http = $http;
        this.notify = notify;
        this.moment = moment;
        this.tableStyle = { 'padding': '0px', 'border': 'none' };
        this.expand = false;
        // receive broadcasts in case some1 wants to expand or collapse sections
        this.socket.forward('expand.all', this.$scope);
        this.$scope.$on('expand.all.' + this.comp, function (event, data) {
            _this.toggle(data);
        });
        this.filterObject = {};
        this.searchCriteria = false;
        this.showSecondary = false;
    }
    MultiController.prototype.$onInit = function () {
        this.goeResult = angular.isDefined(this.item.goeSearchResponse) ? this.item.goeSearchResponse : [];
        this.rowOrder = [];
        if (this.goeResult.length > 0) {
            for (var prop in this.goeResult[0]) {
                this.columnObj = (this.comp && angular.isDefined(this.settings.columnNames[this.comp][prop])) ? this.settings.columnNames[this.comp][prop] : null;
                this.columnObj.v = prop;
                if (this.columnObj.h !== '$$hashKey') {
                    this.rowOrder.push(this.columnObj);
                }
            }
        }
    };
    MultiController.prototype.toggleCriteria = function () {
        this.searchCriteria = !this.searchCriteria;
    };
    MultiController.prototype.clearFilter = function (filtName) {
        this.filterObject.filters[filtName].picked = [];
        this.blurFilterPick();
    };
    MultiController.prototype.searchParams = function () {
        var searchPath = this.item.searchParams;
        return [
            { "name": "Customer Country Landed", "value": searchPath.country },
            { "name": "CMR Num", "value": searchPath.cmrArray },
            { "name": "Address type/Sold To", "value": "true/false" },
            { "name": "CMR Types/Strandard", "value": "true/false" },
        ];
    };
    /**
      Expands or collapses sections
      @param value    boolean to decide if expand or collapse
      @returns void
    */
    MultiController.prototype.toggle = function (value) {
        if (angular.isUndefined(value)) {
            this.expand = this.expand ? false : true;
        }
        else {
            this.expand = value;
        }
    };
    /**
      Toggles the table row, when it contains a secondary row as a table
      @param rowObj    row to be toggled
      @returns void
    */
    MultiController.prototype.toggleRow = function (rowObj) {
        if (angular.isDefined(rowObj.visible) && rowObj.visible) {
            rowObj.visible = false;
        }
        else {
            rowObj.visible = true;
        }
    };
    MultiController.prototype.changedValue = function () {
        this.filterObject.calculated = false;
    };
    MultiController.prototype.makeFilterOptions = function () {
        var _this = this;
        //if (this.filterObject.notEmpty) {
        if (!this.filterObject.calculated && this.filterObject.notEmpty) {
            //browse through every item in table
            this.filterObject.calculated = true;
            angular.forEach(this.item_array, function (tableLine) {
                //if the item is unique, put it into the representing unique value
                for (var prop in _this.filterObject.filters) {
                    if (_this.filterObject.filters[prop].type === 's') {
                        if (_this.filterObject.filters[prop].unique.indexOf(tableLine[prop]) < 0) {
                            _this.filterObject.filters[prop].unique.push(tableLine[prop]);
                        }
                    }
                }
            });
        }
    };
    /**
     Opens the dropdown with the filters. By changing this, we'll change the limitTo of the filter ng-repeat. This is done for
     performance increase(So DOM doenst have to have in special cases 4k+ checkboxes)
     @param id        id of the filter
     @param size      size of the filter
     @returns void
    */
    MultiController.prototype.openDrop = function (id, size) {
        this.countDrop[id] = size;
    };
    /**
     Closes dropdown and sets the limitTo on the filter to 0
     @param id        id of the filter
     @returns void
    */
    MultiController.prototype.closeDrop = function (id) {
        this.countDrop[id] = 0;
        this.blurFilterPick();
    };
    /**
     Based on the filters selected, only those lines in table are picked, that fullfill the picked filter values
     @returns void
    */
    MultiController.prototype.blurFilterPick = function () {
        var _this = this;
        if (!this.filterObject.calculated && this.filterObject.notEmpty) {
            //if (this.filterObject.notEmpty) {
            var tempArray_1 = [];
            var filterOK_1 = true;
            angular.forEach(this.item, function (tableLine) {
                filterOK_1 = true;
                var _loop_1 = function(prop) {
                    if (_this.filterObject.filters[prop].type === 's' && filterOK_1) {
                        if (_this.filterObject.filters[prop].picked.length > 0) {
                            filterOK_1 = false;
                            angular.forEach(_this.filterObject.filters[prop].picked, function (picked) {
                                if (picked === tableLine[prop]) {
                                    filterOK_1 = true;
                                }
                            });
                        }
                    }
                };
                for (var prop in _this.filterObject.filters) {
                    _loop_1(prop);
                }
                if (filterOK_1) {
                    tempArray_1.push(tableLine);
                }
            });
            this.item_array = angular.copy(tempArray_1);
        }
    };
    /**
      Export report into Excel file
      @returns void
    */
    MultiController.prototype.excelExport = function () {
        console.log('sending export Excel request');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'exportReportExcel',
                script: '/detail/eligibility/eligibility',
                token: this.env.user.token,
                data: {
                    id: this.topic.getId(this.topic.topic._id),
                    comp: this.comp,
                    goeResult: this.goeResult,
                    timestamp: this.item.finalTimestamp
                }
            }
        });
    };
    MultiController.prototype.showCmrArrayList = function () {
        var toggleDecision = this.expand ? false : true;
        this.toggle(toggleDecision);
        var items = {
            dialogName: this.item.searchParams.cmrArray
        };
        this.Dialog.updateValidForm(event, items, 'cmrArray-dialog.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
    };
    MultiController.prototype.convertToUnix = function (time) {
        return this.moment.unix(time).format("LLL");
    };
    // Return full name of the country (example "US" => "USA") 
    MultiController.prototype.getCountryFullName = function (country) {
        for (var _i = 0, _a = this.topic.settings.country_list; _i < _a.length; _i++) {
            var e = _a[_i];
            if (e.short === country) {
                return e.cc_text;
            }
        }
    };
    MultiController.$inject = ['$scope', 'socket', 'settings', 'topic', 'Dialog', '$state', '$timeout', 'env', '$http', 'notify', 'moment'];
    return MultiController;
}());
var MultiComponent = (function () {
    function MultiComponent() {
        this.bindings = dcItemBindings;
        this.templateUrl = 'detail-table-multi.html';
        this.controller = MultiController;
    }
    return MultiComponent;
}());
angular
    .module('application')
    .component('multiTable', new MultiComponent());

//# sourceMappingURL=detail.table.multi.component.js.map
